import { Action } from "redux";
import { RegisterBeaconRequestLog } from "../../../service/api-response/BeaconListSuccessResponse";

export const GET_BEACONS_FOR_ORGANIZATION_SUCCESS =
  "BEACON:GET_BEACONS_FOR_ORGANIZATION_SUCCESS";

export interface GetBeaconsForOrganizationSuccessAction extends Action {
  type: typeof GET_BEACONS_FOR_ORGANIZATION_SUCCESS;
  organizationKeyName: string;
  data: RegisterBeaconRequestLog[];
}

export const getBeaconsForOrganizationSuccessAction = (
  organizationKeyName: string,
  data: RegisterBeaconRequestLog[]
): GetBeaconsForOrganizationSuccessAction => ({
  type: GET_BEACONS_FOR_ORGANIZATION_SUCCESS,
  organizationKeyName,
  data,
});
